import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@src/stylus/vuetify.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
})
